<nav mat-tab-nav-bar style="margin-top: 63px; width: 100%">
    <a
        #bla="routerLinkActive"
        *ngIf="isTabMenuVisible('/belege/behandlungsanfragen')"
        [active]="bla.isActive || router.url.startsWith('/belege/behandlungsanfragen')"
        [routerLink]="'/belege/behandlungsanfragen'"
        mat-tab-link
        routerLinkActive
        >Behandlungsanfragen</a
    >
    <a
        #ala="routerLinkActive"
        *ngIf="isTabMenuVisible('/belege/abgabebelege')"
        [active]="ala.isActive || router.url.startsWith('/belege/abgabebelege')"
        [routerLink]="'/belege/abgabebelege'"
        mat-tab-link
        routerLinkActive
        >Abgabebelege</a
    >
    <a
        #bebuela="routerLinkActive"
        *ngIf="showTabBestandsbuch() && isTabMenuVisible('/belege/bestandsbuecher')"
        [active]="bebuela.isActive || router.url.startsWith('/belege/bestandsbuecher')"
        [routerLink]="['/belege/bestandsbuecher']"
        mat-tab-link
        routerLinkActive
    >
        <kiene-tabinfo
            [ladeWennKunde]="true"
            [sendeKundeIdOptional]="true"
            icon=""
            urlpfad="bestandsbuch/tabinfo.php"
        ></kiene-tabinfo>
        &nbsp; Bestandsb&uuml;cher</a
    >
    <a
        #lala="routerLinkActive"
        *ngIf="isTabMenuVisible('/labor/befundmitteilungen')"
        [active]="lala.isActive || router.url.startsWith('/belege/labor/befundmitteilungen')"
        [routerLink]="['/belege/labor/befundmitteilungen']"
        mat-tab-link
        routerLinkActive
    >
        <kiene-tabinfo [sendeKundeId]="true" icon="" urlpfad="antibiogramm/tabinfo.php"></kiene-tabinfo>&nbsp;Labor
    </a>
    <a
        #mpla="routerLinkActive"
        *ngIf="isTabMenuVisible('/belege/massnahmenplaene')"
        [active]="mpla.isActive || router.url.startsWith('/belege/massnahmenplaene')"
        [routerLink]="['/belege/massnahmenplaene']"
        mat-tab-link
        routerLinkActive
    >
        <kiene-tabinfo
            [ladeWennKunde]="true"
            [sendeKundeIdOptional]="true"
            [sendeKundeId]="true"
            urlpfad="massnahmenplan_rind/tabinfo_gesamt.php"
        ></kiene-tabinfo>
        <span>&nbsp;Maßnahmenpläne</span>
    </a>
    <a
        #bbla="routerLinkActive"
        *ngIf="isTabMenuVisible('/belege/bestandsbesuch')"
        [active]="bbla.isActive || router.url.startsWith('/belege/bestandsbesuch')"
        [routerLink]="['/belege/bestandsbesuch']"
        mat-tab-link
        routerLinkActive
    >
        <kiene-tabinfo [sendeKundeId]="true" icon="" urlpfad="bestandsbesuchsprotokoll/tabinfo.php"></kiene-tabinfo>
        &nbsp;Protokolle
    </a>
    <a
        #dla="routerLinkActive"
        *ngIf="isTabMenuVisible('/belege/dokumente')"
        [active]="dla.isActive || router.url.startsWith('/belege/dokumente')"
        [routerLink]="['/belege/dokumente']"
        mat-tab-link
        routerLinkActive
    >
        <kiene-tabinfo
            [ladeWennKunde]="true"
            [sendeKundeIdOptional]="true"
            [sendeKundeId]="true"
            urlpfad="dokument/tabinfo.php"
        ></kiene-tabinfo>
        <span>&nbsp;Dokumente</span>
    </a>
    <a
        #mla="routerLinkActive"
        *ngIf="isTabMenuVisible('/belege/meldungen')"
        [active]="mla.isActive || router.url.startsWith('/belege/meldungen')"
        [routerLink]="['/belege/meldungen']"
        mat-tab-link
        routerLinkActive
    >
        <kiene-tabinfo [urlpfad]="'meldung/tabinfo.php'"></kiene-tabinfo>
        &nbsp;Meldungen QS/HIT</a
    >
    <a
        #gla="routerLinkActive"
        *ngIf="isTabMenuVisible('/belege/gruppen')"
        [active]="gla.isActive || router.url.startsWith('/belege/gruppen')"
        [routerLink]="['/belege/gruppen']"
        mat-tab-link
        routerLinkActive
        >Gruppen</a
    >
</nav>
<router-outlet></router-outlet>
